(function () {
  'use strict';

  // Quantity +/- buttons
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty]');
    if (!btn) return;
    var input = btn.closest('.qty').querySelector('input');
    var val = parseInt(input.value, 10) || 1;
    if (btn.dataset.qty === 'plus') val += 1;
    else val = Math.max(1, val - 1);
    input.value = val;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // AJAX add to cart for product cards
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-ajax-cart], form[action="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    var button = form.querySelector('[type="submit"]');
    var original = button.textContent;
    button.disabled = true;
    button.textContent = '...';
    fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
      method: 'POST',
      body: new FormData(form)
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status && data.status !== 200) throw new Error(data.description || 'Error');
        showToast(form.dataset.addedMessage || 'Added to cart');
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        if (!cart) return;
        document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
        document.querySelectorAll('[data-cart-total]').forEach(function (el) {
          el.textContent = (cart.total_price / 100).toLocaleString(undefined, { minimumFractionDigits: 2 });
        });
      })
      .catch(function (err) { showToast(err.message); })
      .finally(function () { button.disabled = false; button.textContent = original; });
  });

  function showToast(msg) {
    var toast = document.getElementById('CartToast');
    if (!toast) return;
    toast.textContent = msg;
    toast.classList.add('is-visible');
    clearTimeout(toast._t);
    toast._t = setTimeout(function () { toast.classList.remove('is-visible'); }, 2600);
  }

  // Countdown timers
  document.querySelectorAll('[data-countdown]').forEach(function (el) {
    var end = new Date(el.dataset.countdown).getTime();
    if (isNaN(end)) return;
    function tick() {
      var diff = Math.max(0, end - Date.now());
      var d = Math.floor(diff / 86400000);
      var h = Math.floor(diff / 3600000) % 24;
      var m = Math.floor(diff / 60000) % 60;
      var s = Math.floor(diff / 1000) % 60;
      var map = { days: d, hours: h, mins: m, secs: s };
      Object.keys(map).forEach(function (k) {
        var t = el.querySelector('[data-cd-' + k + ']');
        if (t) t.textContent = String(map[k]).padStart(2, '0');
      });
    }
    tick();
    setInterval(tick, 1000);
  });

  // Category dropdown + mobile nav toggle
  document.addEventListener('click', function (e) {
    var catBtn = e.target.closest('[data-categories-toggle]');
    if (catBtn) {
      catBtn.closest('.navbar__categories').classList.toggle('is-open');
      return;
    }
    var navBtn = e.target.closest('[data-nav-toggle]');
    if (navBtn) {
      navBtn.closest('.navbar').classList.toggle('is-open');
      return;
    }
    document.querySelectorAll('.navbar__categories.is-open').forEach(function (el) {
      if (!el.contains(e.target)) el.classList.remove('is-open');
    });
  });

  // Localization selectors auto-submit
  document.querySelectorAll('form[data-localization] select').forEach(function (sel) {
    sel.addEventListener('change', function () { sel.form.submit(); });
  });

  // Product page thumbnail switcher
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-thumb]');
    if (!thumb) return;
    var main = document.querySelector('[data-main-image]');
    if (main) main.src = thumb.dataset.thumb;
  });
})();

/* Back to top */
(function () {
  var btn = document.querySelector('[data-back-to-top]');
  if (!btn) return;
  var toggle = function () { btn.classList.toggle('is-visible', window.scrollY > 400); };
  window.addEventListener('scroll', toggle, { passive: true });
  toggle();
  btn.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
})();

/* Buy now: direct checkout */
document.addEventListener('click', function (e) {
  var btn = e.target.closest('[data-buy-now]');
  if (!btn) return;
  e.preventDefault();
  var productUrl = btn.getAttribute('data-product-url');
  if (productUrl) { window.location.href = productUrl; return; }
  var card = btn.closest('.product-card');
  var qtyInput = card ? card.querySelector('.qty input') : null;
  var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
  var id = btn.getAttribute('data-variant-id');
  window.location.href = '/cart/' + id + ':' + qty;
});

/* ============ Wishlist (saved in browser) ============ */
(function () {
  var KEY = 'kick20_wishlist';
  function get() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  function save(l) { try { localStorage.setItem(KEY, JSON.stringify(l)); } catch (e) {} refresh(); }
  function refresh() {
    var l = get();
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) { el.textContent = l.length; });
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (b) {
      b.classList.toggle('is-active', l.indexOf(b.getAttribute('data-wishlist-toggle')) > -1);
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-wishlist-toggle]');
    if (!b) return;
    e.preventDefault();
    var h = b.getAttribute('data-wishlist-toggle'), l = get(), i = l.indexOf(h);
    if (i > -1) l.splice(i, 1); else l.push(h);
    save(l);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh); else refresh();
})();

/* ============ Quick view popup ============ */
(function () {
  function modal() { return document.getElementById('QuickView'); }
  function money(cents) {
    var f = (window.Kick20 && window.Kick20.moneyFormat) || '${{amount}}';
    return f.replace(/\{\{\s*amount[^}]*\}\}/, (cents / 100).toFixed(2));
  }
  function close() {
    var m = modal(); if (!m) return;
    m.classList.remove('is-open');
    document.body.classList.remove('qv-lock');
  }
  function render(p) {
    var m = modal(); if (!m) return;
    var img = (p.images && p.images[0]) || '';
    var v0 = p.variants.filter(function (v) { return v.available; })[0] || p.variants[0];
    var vHtml = p.variants.length > 1
      ? '<select name="id" aria-label="Options">' + p.variants.map(function (v) {
          return '<option value="' + v.id + '"' + (v.available ? '' : ' disabled') + (v.id === v0.id ? ' selected' : '') + '>' + v.title + ' — ' + money(v.price) + '</option>';
        }).join('') + '</select>'
      : '<input type="hidden" name="id" value="' + v0.id + '">';
    var cmp = v0.compare_at_price && v0.compare_at_price > v0.price ? ' <s class="price--compare">' + money(v0.compare_at_price) + '</s>' : '';
    m.querySelector('.qv__body').innerHTML =
      '<div class="qv__media">' + (img ? '<img src="' + img + '" alt="">' : '') + '</div>' +
      '<div class="qv__info">' +
        '<h3 class="qv__title">' + p.title + '</h3>' +
        '<p class="qv__price price">' + money(v0.price) + cmp + '</p>' +
        '<form method="post" action="/cart/add" data-ajax-cart data-added-message="Added to cart!" class="qv__form">' +
          vHtml +
          '<div class="qty"><button type="button" data-qty="minus" aria-label="-">&minus;</button><input type="number" name="quantity" value="1" min="1" aria-label="Quantity"><button type="button" data-qty="plus" aria-label="+">+</button></div>' +
          '<div class="qv__actions">' +
            '<button type="submit" class="btn">Add to cart</button>' +
            '<button type="button" class="btn btn--buy-now" data-buy-now data-variant-id="' + v0.id + '">Buy now</button>' +
          '</div>' +
        '</form>' +
        '<a class="btn--link" href="/products/' + p.handle + '">View full details</a>' +
      '</div>';
    var sel = m.querySelector('select[name="id"]');
    if (sel) sel.addEventListener('change', function () {
      m.querySelector('[data-buy-now]').setAttribute('data-variant-id', sel.value);
      var v = p.variants.filter(function (x) { return String(x.id) === sel.value; })[0];
      if (v) m.querySelector('.qv__price').innerHTML = money(v.price) + (v.compare_at_price && v.compare_at_price > v.price ? ' <s class="price--compare">' + money(v.compare_at_price) + '</s>' : '');
    });
    m.classList.add('is-open');
    document.body.classList.add('qv-lock');
  }
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-quick-view]');
    if (open) {
      e.preventDefault();
      var h = open.getAttribute('data-quick-view');
      fetch('/products/' + h + '.js').then(function (r) { return r.json(); }).then(render)
        .catch(function () { window.location.href = '/products/' + h; });
      return;
    }
    if (e.target.closest('[data-qv-close]') || e.target === modal()) close();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.qv [data-buy-now]');
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    var m = modal();
    var q = m.querySelector('input[name="quantity"]');
    var qty = q ? Math.max(1, parseInt(q.value, 10) || 1) : 1;
    window.location.href = '/cart/' + b.getAttribute('data-variant-id') + ':' + qty;
  }, true);
})();

/* ============ Mobile sliders ============ */
(function () {
  function setup(grid) {
    if (grid.dataset.sliderInit) return;
    grid.dataset.sliderInit = '1';
    var paused = false, dir = 1;
    ['touchstart', 'pointerdown', 'mouseenter'].forEach(function (ev) {
      grid.addEventListener(ev, function () { paused = true; }, { passive: true });
    });
    grid.addEventListener('mouseleave', function () { paused = false; });
    setInterval(function () {
      if (paused || window.innerWidth > 767) return;
      var max = grid.scrollWidth - grid.clientWidth;
      if (max <= 0) return;
      if (grid.scrollLeft >= max - 4) dir = -1;
      if (grid.scrollLeft <= 4) dir = 1;
      var card = grid.firstElementChild;
      var step = card ? card.offsetWidth + 18 : 300;
      grid.scrollBy({ left: step * dir, behavior: 'smooth' });
    }, 4200);
  }
  function init() { document.querySelectorAll('.testimonial-grid, .blog-grid').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();